import React from 'react'
// import image from '../assets/underCun.gif';
import image from '../assets/website_under_construction1.png';

const UnderCun = () => {
    return (
        <div className='coming'>
            <img src={image} alt="Under Construction" style={{ width: '700px' }} />
        </div>
    )
}

export default UnderCun
